module.exports = __webpack_public_path__ + "static/media/cours.744caa8b.jpg";